export default "__VITE_ASSET__92d8ae01__"